'use client';
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Script from 'next/script';

const HUBSPOT_PORTAL_ID = process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID || '';

declare global {
  interface Window {
    _hsq?: any[];
  }
}

export default function HubSpotTracker() {
  const pathname = usePathname();
  const [mounted, setMounted] = useState(false);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  // Initialize _hsq queue as early as possible
  useEffect(() => {
    // Initialize HubSpot tracking queue
    if (typeof window !== 'undefined') {
      window._hsq = window._hsq || [];
    }

    setMounted(true);
  }, []);

  // Handle path changes
  useEffect(() => {
    if (mounted && typeof window !== 'undefined' && window._hsq) {
      window._hsq.push(['setPath', pathname]);

      // Only track page views after script has loaded to prevent double tracking
      if (scriptLoaded) {
        window._hsq.push(['trackPageView']);
      }
    }
  }, [pathname, mounted, scriptLoaded]);

  // Don't render during SSR
  if (!mounted) return null;

  // Only include in production
  if (!HUBSPOT_PORTAL_ID) return null;

  return (
    <>
      <Script
        id='hubspot-tracking'
        strategy='lazyOnload' // Use lazyOnload for non-critical scripts
        src={`https://js.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js?loadImmediately=false`}
        onLoad={() => {
          setScriptLoaded(true);
          // Initial page view tracking
          window._hsq?.push(['trackPageView']);
        }}
      />
      {/* Add a dedicated container for the cookie consent banner */}
      <div id='hs-cookie-consent-container' />
    </>
  );
}
